import SectionHero from "../inner-page/sectionHero";
import SectionDiscount from "../inner-page/sectionDiscount";
import SectionRetention from "../inner-page/sectionRetention";
import SectionTips from "../inner-page/sectionTips";
import SectionCta from "../inner-page/sectionCta";
import SectionYotpoProducts from "../inner-page/sectionYotpoProducts";
import SectionSmsExamples from "../inner-page/sectionSmsExamples";
import SectionSmsAssets from "../inner-page/sectionSmsAssets";
import SectionDownloads from "../inner-page/sectionDownloads";
import { useLocation } from "react-router-dom";

import "../../css/innerPage.scss";

const BeforePage = (props) => {
  const location = useLocation();

  let videoId = "";
  if (location.state != null && location.state.videoId != null) {
    videoId = location.state.videoId;
  }

  return (
    <>
      <main className={`inner-page ${props.color}`}>
        <SectionHero {...props.hero} />
        {props.discount.display_section && <SectionDiscount {...props.discount} />}
        {props.retention.display_section && <SectionRetention {...props.retention} />}
        {props.tips.display_section && <SectionTips {...props.tips} />}
        {props.cta.display_section && <SectionCta {...props.cta} />}
        {props.yotpo_products.display_section && <SectionYotpoProducts {...props.yotpo_products} videoId={videoId} />}
        {props.sms_examples.display_section && <SectionSmsExamples {...props.sms_examples} />}
        {props.sms_assets.display_section && <SectionSmsAssets {...props.sms_assets} />}
        {props.downloads.display_section && <SectionDownloads {...props.downloads} />}
      </main>
    </>
  );
};

export default BeforePage;
